// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1K9E4","checkboxCol":"Table_checkboxCol__178AX","emailCol":"Table_emailCol__-RWSv","actionCol":"Table_actionCol__3M5Vk"};